import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { verifyEmail as verifyEmailService } from 'Services/VerifyEmail/EmailVerification';
import { LoggerFactory, DOMAIN, FEATURE } from 'Services/Logger';
import { removeSignInVerifyEmailData } from 'Utils/verifyEmail';
import { withConfig } from 'Contexts/Config';
import Loading from 'Redesign_Funnel/components/Loading';
import { useLocalStorage } from 'Hooks/useStorage';
import ErrorEmailVerification from './ErrorEmailVerification';
import ResendEmailVerification from './ResendEmailVerification';
import SuccessEmailVerification from './SuccessEmailVerification';
import { EMAIL_VERIFICATION_STATUS } from './EmailVerification.constants';
import { EmailVerificationLayout } from './components/EmailVerificationLayout';

const emailVerifiedMessage = 'Email already verified';
const Logger = LoggerFactory.getLogger(DOMAIN.CONSUMER_ENABLEMENT);

const EmailVerification = () => {
  const { search: query } = useLocation();
  const sendEmailDefault = query.includes('send_email');
  const token = new URLSearchParams(query).get('token');
  const [isSendEmail, setIsSendEmail] = useState(false);
  const [isErrorVerification, setIsErrorVerification] = useState(false);
  const [isSuccessVerification, setIsSuccessVerification] = useState(false);
  useLocalStorage(EMAIL_VERIFICATION_STATUS);

  const verifyEmail = () => {
    verifyEmailService({ token })
      .then((response) => {
        if (response && response.status === 'success') {
          if (response.data.message === emailVerifiedMessage) {
            setIsErrorVerification(true);
            return;
          }
          setIsSuccessVerification(true);
          removeSignInVerifyEmailData();
        } else setIsErrorVerification(true);
      })
      .catch((err) => {
        setIsErrorVerification(true);

        Logger.warn(
          'Error Verify Email',
          `${FEATURE.LOGIN}`,
          {
            error: err?.response?.data?.message,
          },
        );
      });
  };

  useEffect(() => {
    if (token) verifyEmail();
    else setIsSendEmail(true);
  }, [token]);

  if (isErrorVerification) {
    return (
      <EmailVerificationLayout>
        <ErrorEmailVerification />
      </EmailVerificationLayout>
    );
  }

  if (isSuccessVerification) {
    return (
      <EmailVerificationLayout>
        <SuccessEmailVerification />
      </EmailVerificationLayout>
    );
  }

  if (isSendEmail) {
    return (
      <EmailVerificationLayout>
        <ResendEmailVerification sendByDefault={sendEmailDefault} />
      </EmailVerificationLayout>
    );
  }

  return (
    <EmailVerificationLayout>
      <Loading />
    </EmailVerificationLayout>
  );
};

EmailVerification.propTypes = {};

export default withConfig(EmailVerification);
